import { render, staticRenderFns } from "./df-footer.vue?vue&type=template&id=8d571c2a&"
import script from "./df-footer.ts?vue&type=script&lang=js&"
export * from "./df-footer.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports